export default function RuleItem({ icon, text }) {
  return (
    <li className="p-3 bg-event-tertiary text-white/80 min-h-19 transition-colors rounded-md shadow-sm flex items-center gap-3">
      {icon && <div className="flex-shrink-0">{icon}</div>}
      <p className={'text-[.85rem]'}>{text}</p>
    </li>
  );
}
